import React from "react";


const DailyQuestionModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <>
       <style>{`
      .unlockModal .confirm-btn.daily-btn{
        border-radius:999px!important;
     }
      .unlockModal .modal-container {
         border-radius: 15px!important;
      }
      .questiondesc{
         font-size:14px;
        }
      .unlockModal .confirm-btn.daily-btn {
         height: 45px;
      }
     `}</style>
      <div
        className="modal-overlay resetModal unlockModal text-center daily-popup"
        onClick={onClose}
      >
        <div
          className="modal-container"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <div className="close-btn2 text-end unlock-close-btn">
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            />
          </div>

          {/* Icon */}
          <div className="premium-icon daily-icon">
            <i className="bi bi-info-circle"></i>
          </div>

          {/* Title */}
          <h5 className="fw-bold blackText mb-2">
            Daily Question
          </h5>

          {/* Description */}
          <p className="grayText fw-medium questiondescp">
            You did not attempt this question on that day.
          </p>

          {/* Button */}
          <div className="btns-popup action-btns">
            <button
              type="button"
              className="confirm-btn fw-semibold text-white daily-btn"
              onClick={onClose}
            >
              Okay
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DailyQuestionModal;